import { DeviationTypes, DeviationResourceType, } from '../types/deviation';
import { DEVIATION_PATHS } from '@wix/da-url/dist/src/constants';
import { Url } from '@wix/da-url';
import { getFeature } from '../DaEditorWrapper/Features/helper';
import { MEDIA_COUNT_FEATURE } from '../DaEditorWrapper/Features/mediaCount';
var CHARS_BEFORE_LONG_STATUS = 110;
export var JOURNAL_CATEGORY_PREFIXES = ['journals', 'personaljournal'];
// for fullviews/art stage
var TINY_IMAGE_THRESHOLD_WIDTH = 400;
var TINY_IMAGE_THRESHOLD_HEIGHT = 400;
var TINY_IMAGE_THRESHOLD_WIDTH_MOBILE = 200;
var TINY_IMAGE_THRESHOLD_HEIGHT_MOBILE = 180;
export function styleFromWidthHeight(_a, responsive) {
    var width = _a.width, height = _a.height;
    if (responsive === void 0) { responsive = true; }
    // if nothing is set, always fill container
    if (!width && !height) {
        return {
            width: '100%',
            height: '100%',
        };
    }
    // if responsive mode, or both props are set - just use whatever is set
    if (responsive || (width && height)) {
        return { width: width, height: height };
    }
    // otherwise try to square it off
    return {
        width: width || height || '100%',
        height: height || width || '100%',
    };
}
export var getDeviationFile = function (deviation, fileType) {
    var files = deviation && deviation.files;
    return files && files.find(function (f) { return f.type === fileType; });
};
export function getThumbSet(deviation, allowPreview, allowFullview) {
    if (allowPreview === void 0) { allowPreview = false; }
    if (allowFullview === void 0) { allowFullview = false; }
    var thumbFileTypes = [
        '150',
        '200H',
        '300W',
        '200T',
        '250T',
        '350T',
        '400T',
    ];
    if (allowPreview) {
        thumbFileTypes.push('preview');
        thumbFileTypes.push('social_preview');
    }
    if (allowFullview) {
        thumbFileTypes.push('fullview');
    }
    if (!deviation || !deviation.files) {
        return [];
    }
    return deviation.files.filter(function (file) { return thumbFileTypes.includes(file.type); });
}
export function getLargestFullview(deviation) {
    var fvs = getFullviews(deviation);
    var type = getDeviationType(deviation);
    if (fvs.length === 0 ||
        type === DeviationTypes.JOURNAL ||
        type === DeviationTypes.LITERATURE) {
        return {
            type: 'unknown',
            src: '',
            width: 1000,
            height: 1000,
            isDefault: true,
        };
    }
    return fvs.reduce(function (prev, curr) {
        if ((prev.width || 0) > (curr.width || 0) ||
            (prev.height || 0) > (curr.height || 0)) {
            return prev;
        }
        return curr;
    });
}
export function getFullviews(deviation) {
    if (!deviation || !deviation.files) {
        return [];
    }
    // for gif images only the gif file is a valid fullview
    var gif = getDeviationFile(deviation, 'gif');
    if (gif) {
        return [gif];
    }
    return deviation.files.filter(function (file) { return /^fullview|preview|original/.test(file.type) && file; });
}
export function getDeviationType(deviation) {
    if (!deviation) {
        return DeviationTypes.UNKNOWN;
    }
    // polls
    if (deviation.poll) {
        return DeviationTypes.POLL;
    }
    // commission
    if (deviation.commission) {
        return DeviationTypes.COMMISSION;
    }
    // status
    if (deviation.status) {
        return DeviationTypes.STATUS;
    }
    // Motion books
    if (deviation.motionBook) {
        return DeviationTypes.MOTIONBOOK;
    }
    // Freeforms
    if (deviation.textContent) {
        if (deviation.isJournal) {
            return DeviationTypes.JOURNAL;
        }
        return DeviationTypes.LITERATURE;
    }
    if (!deviation.files) {
        return DeviationTypes.UNKNOWN;
    }
    var fileTypes = {};
    var defaultFilesCount = 0;
    for (var _i = 0, _a = deviation.files; _i < _a.length; _i++) {
        var file = _a[_i];
        fileTypes[file.type] = true;
        if (file.isDefault) {
            defaultFilesCount++;
        }
    }
    // Video
    if (fileTypes.video) {
        return DeviationTypes.FILM;
    }
    // Flash
    if (fileTypes.flash) {
        return DeviationTypes.FLASH;
    }
    // PDF
    if (fileTypes.pdf) {
        return DeviationTypes.PDF;
    }
    // GIF
    if (fileTypes.gif) {
        return DeviationTypes.IMAGE;
    }
    // Image
    if (defaultFilesCount !== deviation.files.length) {
        return DeviationTypes.IMAGE;
    }
    return DeviationTypes.UNKNOWN;
}
export function getDeviationResourceType(deviation) {
    var type = getDeviationType(deviation);
    switch (type) {
        case DeviationTypes.JOURNAL:
            return DeviationResourceType.JOURNAL;
        case DeviationTypes.POLL:
            return DeviationResourceType.POLL;
        case DeviationTypes.COMMISSION:
            return DeviationResourceType.COMMISSION;
        case DeviationTypes.STATUS:
            return DeviationResourceType.STATUS;
        default:
            return DeviationResourceType.ART;
    }
}
export function isDeviationPixelArt(deviation) {
    return false; // we don't support pixel detection for now
}
export function isDeviationTransparent(deviation) {
    // get our representative fullview file
    var fullview = getLargestFullview(deviation);
    // and see if it's transparent
    return !!fullview.transparency;
}
export function isDeviationTextEditable(deviation) {
    var isTextEditable = !!deviation.isTextEditable;
    var hasLegacyTextEditUrl = !!deviation.legacyTextEditUrl;
    switch (getDeviationType(deviation)) {
        case DeviationTypes.LITERATURE:
        case DeviationTypes.JOURNAL:
            return isTextEditable || hasLegacyTextEditUrl;
        case DeviationTypes.COMMISSION:
        case DeviationTypes.POLL:
        case DeviationTypes.STATUS:
            return isTextEditable;
        default:
            return false;
    }
}
export var isImageDeviation = function (deviation) {
    return getDeviationType(deviation) === DeviationTypes.IMAGE;
};
export function getDeviationBasePath(deviation) {
    switch (getDeviationType(deviation)) {
        case DeviationTypes.JOURNAL:
            return DEVIATION_PATHS.JOURNAL;
        case DeviationTypes.COMMISSION:
            return DEVIATION_PATHS.COMMISSION;
        case DeviationTypes.POLL:
            return DEVIATION_PATHS.POLL;
        case DeviationTypes.STATUS:
            return DEVIATION_PATHS.STATUS;
        default:
            return DEVIATION_PATHS.DEVIATION;
    }
}
export function getDeviationUrl(deviation, useUrl) {
    if (useUrl === void 0) { useUrl = true; }
    var deviationId = deviation.deviationId, deviationTitle = deviation.title, author = deviation.author, url = deviation.url;
    if (useUrl && url) {
        return url;
    }
    return Url.deviationLink(deviationId, author && author.username.toLowerCase(), deviationTitle, getDeviationBasePath(deviation));
}
export function getDeviationPath(deviation) {
    var deviationId = deviation.deviationId, deviationTitle = deviation.title, author = deviation.author;
    return Url.deviationPath(deviationId, author && author.username.toLowerCase(), deviationTitle, getDeviationBasePath(deviation));
}
export function isValidFileSrc(src) {
    return (/^https:\/\/(.+)\.deviantart\.net/.test(src) ||
        /^https:\/\/images-wixmp-ed30a86b8c4ca887773594c2/.test(src) ||
        /^https:\/\/images-wixmp-395331243bc2089e8c09c8d3/.test(src));
}
export function getFilePixelSize(file) {
    return (file.width || 0) * (file.height || 0);
}
export function getFullviewForSize(deviation, width, height) {
    var fullviews = getFullviews(deviation);
    if (!fullviews.length) {
        return;
    }
    // sort by resolution
    fullviews.sort(function (a, b) {
        return getFilePixelSize(a) - getFilePixelSize(b);
    });
    // find smallest fitting file
    if (width && height) {
        var file = fullviews.find(function (f) {
            if (!f.width || !f.height) {
                return false;
            }
            return f.width >= width && f.height >= height;
        });
        if (file) {
            return file;
        }
    }
    // if no fitting file was found return largest one
    return fullviews[fullviews.length - 1];
}
export function isFileLargerThanSize(file, width, height) {
    if (!width || !height || !file.width || !file.height) {
        return false;
    }
    return file.width > width || file.height > height;
}
export function isFileTiny(file, isMobile) {
    if (!file.width || !file.height) {
        return false;
    }
    var thresholdWidth = isMobile
        ? TINY_IMAGE_THRESHOLD_WIDTH_MOBILE
        : TINY_IMAGE_THRESHOLD_WIDTH;
    var thresholdHeight = isMobile
        ? TINY_IMAGE_THRESHOLD_HEIGHT_MOBILE
        : TINY_IMAGE_THRESHOLD_HEIGHT;
    return file.width < thresholdWidth && file.height < thresholdHeight;
}
export function scaleToSize(content, container) {
    // if anything is missing, bail
    if (!content.width ||
        !content.height ||
        !container.width ||
        !container.height) {
        return;
    }
    // if our content is small enough, noop
    if (content.width <= container.width && content.height <= container.height) {
        return { width: content.width, height: content.height };
    }
    // we need to check along which axis do we need to scale more (ie. smaller scale factor)
    var widthScale = container.width / content.width;
    var heightScale = container.height / content.height;
    if (widthScale < heightScale) {
        return {
            width: container.width,
            height: content.height * widthScale,
        };
    }
    return {
        width: content.width * heightScale,
        height: container.height,
    };
}
export function getSmallestThumb(deviation) {
    var thumbset = getThumbSet(deviation);
    var thumb = thumbset.reduce(function (smallest, current) {
        if (!smallest || !smallest.width) {
            return current;
        }
        if (!current.width) {
            return smallest;
        }
        return smallest.width > current.width ? current : smallest;
    }, undefined);
    return thumb && thumb.src;
}
export function getIsShortStatus(_a) {
    var textContent = _a.textContent;
    if (!textContent) {
        return false;
    }
    var isLegacy = textContent.html.type === 'writer';
    var hasMedia = false;
    if (!isLegacy) {
        var mediaCounts = getFeature(MEDIA_COUNT_FEATURE, textContent.html.features);
        if (mediaCounts &&
            (mediaCounts.data.images > 0 || mediaCounts.data.video > 0)) {
            hasMedia = true;
        }
    }
    return textContent.excerpt.length < CHARS_BEFORE_LONG_STATUS && !hasMedia;
}
export function getTranslatedDeviationTitle(_a, t) {
    var title = _a.title, author = _a.author;
    if (!author) {
        return title;
    }
    return t('deviation.deviationTitle', { title: title, author: author.username });
}
export function getIsTextType(deviation) {
    return [
        DeviationTypes.LITERATURE,
        DeviationTypes.JOURNAL,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation));
}
export function getIsStreamTextType(deviations) {
    return deviations.every(function (deviation) { return getIsTextType(deviation); });
}
export function deviationTypeToTranslationKey(type) {
    var _a;
    var typeMap = (_a = {},
        _a[DeviationTypes.COMMISSION] = 'commission',
        _a[DeviationTypes.POLL] = 'poll',
        _a[DeviationTypes.STATUS] = 'status',
        _a[DeviationTypes.JOURNAL] = 'journal',
        _a);
    return typeMap.hasOwnProperty(type)
        ? "common." + typeMap[type]
        : "common.deviation";
}
//# sourceMappingURL=_helpers.js.map